interface FilterBadgeProps {
  count: number;
}

const FilterBadge = ({ count }: FilterBadgeProps) => {
  return (
    <span className="ml-0.5 inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-gray-100 px-1.5 text-xs font-medium text-gray-600">
      {count}
    </span>
  );
};

export default FilterBadge;
